import { ButtonProps } from './types';
import styles from './PrimaryButton.module.css';

export const PrimaryButton = ({
  className,
  disabled = false,
  hide = false,
  onClick,
  text,
  type,
}: ButtonProps) => {
  return (
    <button
      className={`${className ? className + ' ' : ''}${styles.primaryButton}`}
      type={type}
      disabled={disabled}
      style={{ display: hide ? 'none' : 'inline-block' }}
      onClick={onClick}
    >
      <span className={styles.primaryButtonText}>{text}</span>
    </button>
  );
};
